import { combineReducers } from "redux"
import { ActionTypes } from "../actions"

const open = (state = false, action: any) => {
  switch (action.type) {
    case ActionTypes.OPEN_SIDEBAR:
      return true
    case ActionTypes.CLOSE_SIDEBAR:
      return false
    default:
      return state
  }
}

export default combineReducers({
  open
})

export const isSidebarOpened = (state: any) => state.open
